import React from 'react';
import PropTypes from 'prop-types';
import { decode } from 'jsonwebtoken';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Paragraph from '../../Paragraph/Paragraph';
import Modal from '../../Modal';
import Button from '../../Buttons/Button';
import themeColors from '../../../assets/styles/themeColors';
import { retrieveFromSessionStorage } from '../../../util/helpers/sessionStorageHelper';
import { mediaBelow, pxToRem, pxToRemMd } from '../../../assets/styles/helper';
import { variables } from '../../../assets/styles/variables';
// import { ReactComponent as Success } from '../../../assets/images/svg/success-invitation.svg';

const SalesAssistedModalButton = styled(Button)`
  > p {
    color: ${themeColors.colorTextSecondary};
  }
  background-color: ${themeColors.colorWhite};
  min-width: ${pxToRem(104)};
  padding: ${pxToRem(8)} ${pxToRem(22)};
  font-size: ${pxToRem(16)};
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.5;
  border: 1px solid ${themeColors.colorTextSecondary};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    margin-left: 0;
    margin-top: ${pxToRemMd(12)};
    min-width: 0;
    width: 100%;
    padding: ${pxToRemMd(8)} ${pxToRemMd(30)};
    font-size: ${pxToRemMd(16)};
    border: 1px solid ${themeColors.colorTextSecondary};
  }
`;
const SalesAssistedSuccess = styled.div`
  background-color: ${themeColors.colorSuccess};
  display: flex;
  padding: ${pxToRem(20)} ${pxToRem(22)};
  justify-content: center;
  align-items: center;
  ${mediaBelow(variables.breakpoints.bpXl)} {
    padding: ${pxToRemMd(20)} ${pxToRemMd(22)};
  }
`;

// const SalesAssistedSuccessIcon = styled(Success)`
//   width: ${pxToRem(40)};
//   height: ${pxToRem(40)};
//   color: ${themeColors.colorSuccess};

//   ${mediaBelow(variables.breakpoints.bpXl)} {
//     width: ${pxToRemMd(20)};
//     height: ${pxToRemMd(20)};
//     margin-right: ${pxToRemMd(8)};
//   }
// `;

const SalesAssistedModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const JwtToken = retrieveFromSessionStorage('JwtToken');
  const { CustomerEmail } = decode(JwtToken);

  return (
    <Modal
      variant="md"
      isOpen={isOpen}
      onClose={onClose}
      label={t('salesAssisted.invitationTitle')}
      smallPadding
    >
      <SalesAssistedSuccess>
        {/* <SalesAssistedSuccessIcon /> */}
      </SalesAssistedSuccess>
      <Paragraph
        color={themeColors.colorBlack}
        mb={14}
        mt={14}
        fontWeight="bold"
      >
        {t('salesAssisted.invitationSubtitle')}
      </Paragraph>
      <Paragraph color={themeColors.colorTextXLLight} mb={28}>
        {t('salesAssisted.invitationDescription', { email: CustomerEmail })}
      </Paragraph>
      <SalesAssistedModalButton
        onClick={() => onClose()}
        variant="primaryOutlined"
        title="Ok, return to back office"
      />
    </Modal>
  );
};

SalesAssistedModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SalesAssistedModal;
